/** @jsxImportSource theme-ui */
import React from 'react';

import { Typography } from '../Typography';

type ScoreBarProps = {
  label: string;
  score: number;
};
const ScoreBar: React.FC<ScoreBarProps> = ({ label, score }) => {
  const validScore: number = Math.round(Math.min(100, Math.max(0, score)));
  return (
    <div sx={{ width: '100%' }}>
      <Typography variant="body2" color="stone70" marginBottom="0">
        {label}
      </Typography>
      <div
        sx={{
          width: '100%',
          height: '4px',
          backgroundColor: 'deepSea20',
          borderRadius: '2px',
          margin: '8px 12px 6px 0',
        }}
      >
        <div
          data-testid="score-bar-inner"
          sx={{
            width: `${validScore}%`,
            height: '100%',
            backgroundColor: 'deepSea50',
            borderRadius: validScore === 100 ? '2px' : '2px 0px 0px 2px',
          }}
        />
      </div>
      <Typography data-testid="score-bar-text" variant="overline" color="stone90">
        {validScore}/100
      </Typography>
    </div>
  );
};

export default ScoreBar;
